import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import type { CampaniaPendiente, HistorialReporte, HistorialReporteWhatsApp } from '../types'

export function useCampaniasPendientes(search?: string, marcaPrincipalId?: number, tab: string = 'sin_reporte') {
  return useQuery({
    queryKey: ['seguimiento-reportes', 'campanias', search, marcaPrincipalId, tab],
    queryFn: async () => {
      const params = new URLSearchParams()
      if (search) params.append('search', search)
      if (marcaPrincipalId) params.append('marca_principal_id', String(marcaPrincipalId))
      params.append('tab', tab)
      const qs = params.toString()
      const { data } = await apiClient.get<CampaniaPendiente[]>(
        `/multichannel/seguimiento-reportes/campanias/${qs ? `?${qs}` : ''}`
      )
      return data
    },
  })
}

export function useHistorialReporte(campaniaId: number) {
  return useQuery({
    queryKey: ['seguimiento-reportes', 'historial', campaniaId],
    queryFn: async () => {
      const { data } = await apiClient.get<HistorialReporte[]>(
        `/multichannel/reportes/por-campania/${campaniaId}/historial/`
      )
      return data
    },
    enabled: !!campaniaId,
  })
}

export function useHistorialReporteWhatsApp(campaniaId: number) {
  return useQuery({
    queryKey: ['seguimiento-reportes', 'historial-wa', campaniaId],
    queryFn: async () => {
      const { data } = await apiClient.get<HistorialReporteWhatsApp[]>(
        `/multichannel/reportes-whatsapp/por-campania/${campaniaId}/historial/`
      )
      return data
    },
    enabled: !!campaniaId,
  })
}
